<template>
  <div class="list-box" style="padding: 0; padding-top: 10px">
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <el-input
          v-model="state.params.name"
          style="width: 200px"
          placeholder="姓名"
          clearable
          @clear="
            delete state.params.name;
            onLoad();
          "
        ></el-input>
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
      <el-button
        type="danger"
        v-if="$judge_auth('132') && [1, 2].includes(props.model?.status)"
        link
        icon="Close"
        @click="onSetFailure"
      >
        发放失败
      </el-button>
      <el-button
        type="success"
        v-if="$judge_auth('132') && [1, 2].includes(props.model?.status)"
        link
        icon="Select"
        @click="onSetDone"
      >
        标记已发放
      </el-button>
      <!-- <el-button type="success" link icon="Select" @click="onSetDone">
        标记已发放
      </el-button> -->
      <el-button
        type="warning"
        v-if="
          $judge_auth('132') &&
          [1, 2].includes(props.model?.status) &&
          props.model?.withholding_agent_type == 0 &&
          props.model?.is_interface == 1
        "
        link
        icon="Position"
        @click="onShowPayForYinQi"
      >
        银企发放
      </el-button>
    </ul>
    <ul class="list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        class="payroll-record-table"
        @row-click="onRowClick"
        :summary-method="getSummaries"
        show-summary
      >
        <el-table-column type="selection" width="55" fixed />
        <el-table-column
          fixed
          label="序号"
          width="70"
          prop="sn"
          align="center"
        />
        <el-table-column label="算税状态" width="120" align="center">
          <template #default="{ row }">
            <el-tooltip
              effect="dark"
              :content="row.tax_failure_msg"
              v-if="row.tax_failure_msg"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                "
              >
                <c_status
                  arrName="payrollemployee_tax_status"
                  :value="row.tax_status"
                />
                <el-icon><QuestionFilled /></el-icon>
              </div>
            </el-tooltip>
            <c_status
              arrName="payrollemployee_tax_status"
              :value="row.tax_status"
              style="margin: 0 auto"
              v-else
            ></c_status>
          </template>
        </el-table-column>
        <el-table-column label="发放状态" width="120" align="center">
          <template #default="{ row }">
            <div v-if="row.is_interface == 1 && row.pay_status == 2">
              银企发放中
            </div>
            <template v-else>
              <el-tooltip
                effect="dark"
                :content="row.pay_failure_msg"
                v-if="row.pay_failure_msg"
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                  "
                >
                  <c_status
                    arrName="salarypayment_record_status"
                    :value="row.pay_status"
                  />
                  <el-icon><QuestionFilled /></el-icon>
                </div>
              </el-tooltip>
              <c_status
                arrName="salarypayment_record_status"
                :value="row.pay_status"
                style="margin: 0 auto"
                v-else
              ></c_status>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          :prop="item.field"
          :label="item.name"
          v-for="item in state.templateSortFields.filter(
            (w) => !['sn', 'remark'].includes(w.field)
          )"
          :key="item"
          :width="['idcard'].includes(item.field) ? 180 : 140"
          align="center"
        >
          <template #default="{ row, column }">
            <div
              v-if="row.isEdit && row.edit.includes(column.property)"
              @click.stop=""
            >
              <el-input-number
                v-model="row[column.property]"
                style="width: 100%"
                :precision="2"
                controls-position="right"
              ></el-input-number>
            </div>
            <template v-else>
              <div v-if="row[column.property]">
                {{ row[column.property] }}
              </div>
              <text v-else>-</text>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" :width="180" align="center">
          <template #default="{ row }">
            <el-input
              v-model="row.remark"
              v-if="row.isEdit"
              @click.stop=""
            ></el-input>
            <text v-else>
              {{ row.remark || "-" }}
            </text>
          </template>
        </el-table-column>
      </el-table>
    </ul>
    <el-dialog
      v-model="state.showDone"
      title="标记成功"
      width="500"
      align-center
    >
      <el-form
        :model="state.uploadModel"
        ref="uploadDom"
        label-width="auto"
        label-position="top"
      >
        <el-form-item
          label="附件"
          prop="attachment_id"
          :rules="[
            {
              required: true,
              message: '请上传附件',
              trigger: 'blur',
            },
          ]"
          style="position: relative"
        >
          <el-upload
            :show-file-list="false"
            :auto-upload="false"
            :multiple="true"
            accept=".jpeg,.jpg,.png,.gif"
            :on-change="onChangeFile"
            style="position: absolute; right: 0; top: -40px"
          >
            <template #trigger>
              <el-button type="warning" size="small">选择文件</el-button>
            </template>
          </el-upload>
          <div>
            <ul
              v-for="(item, index) in state.files"
              :key="item"
              style="display: flex; align-items: center; line-height: 30px"
            >
              <el-icon><Document /></el-icon>
              <li
                style="
                  flex: 1;
                  overflow: hidden;
                  height: 30px;
                  margin-left: 5px;
                "
              >
                {{ item.filename }}
              </li>
              <el-button
                link
                icon="delete"
                type="danger"
                size="large"
                @click="
                  state.files.splice(index, 1);
                  state.uploadModel.attachment_id = (state.files || [])
                    .map((m) => m.id)
                    .join(',');
                "
              ></el-button>
            </ul>
          </div>
        </el-form-item>
        <el-form-item label="附件说明" prop="desc">
          <el-input
            v-model="state.uploadModel.attachment_remark"
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="state.showDone = false">取消</el-button>
          <el-button type="primary" @click="onSubmitDone">提交</el-button>
        </div>
      </template>
    </el-dialog>
    <!-- <el-dialog
      v-model="state.showDone"
      title="标记成功"
      width="500"
      align-center
    >
      <div style="display: flex; align-items: center; width: 100%">
        <li style="flex: 1">上传电子回单</li>
        <el-upload
          :show-file-list="false"
          :auto-upload="false"
          :multiple="true"
          accept=".jpeg,.jpg,.png,.gif"
          :on-change="onChangeFile"
        >
          <template #trigger>
            <el-button type="warning" size="small">选择文件</el-button>
          </template>
        </el-upload>
      </div>
      <div>
        <ul
          v-for="(item, index) in state.files"
          :key="item"
          style="display: flex; align-items: center; line-height: 30px"
        >
          <el-icon><Document /></el-icon>
          <li style="flex: 1; overflow: hidden; height: 30px; margin-left: 5px">
            {{ item.filename }}
          </li>
          <el-button
            link
            icon="delete"
            type="danger"
            size="large"
            @click="state.files.splice(index, 1)"
          ></el-button>
        </ul>
      </div>
      <template #footer>
        <div
          class="dialog-footer"
          :style="{ marginTop: state.files?.length > 0 ? '0' : '30px' }"
        >
          <el-button @click="state.showDone = false">取消</el-button>
          <el-button type="primary" @click="onSubmitDone">标记成功</el-button>
        </div>
      </template>
    </el-dialog> -->
    <el-dialog
      v-model="state.showPayForYinQi"
      title="银企发放"
      width="500"
      align-center
    >
      <el-form
        :model="state.payModel"
        ref="formDom"
        style="width: 100%; margin-top: 10px"
      >
        <el-form-item
          label="发放账户"
          prop="bank_account_pay"
          :rules="[
            {
              required: true,
              message: '请选择发放账户',
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            v-model="state.payModel.bank_account_pay"
            placeholder="请选择发放账户"
            size="large"
            popper-class="custom-select-auto-height"
            value-key="id"
          >
            <el-option
              v-for="item in state.bank_account_data"
              :key="item"
              :value="item"
              :label="item.name + item.bank"
            >
              <div style="padding: 5px 0">
                <ul style="display: flex; align-items: center">
                  <li style="flex: 1">
                    {{ item.name }}
                  </li>
                  <text v-if="item.bank" style="color: #a2a2a2; font-size: 90%">
                    {{ item.bank }}
                  </text>
                </ul>
                <ul style="color: #a2a2a2; font-size: 90%; margin-top: 3px">
                  {{
                    item.account
                  }}
                </ul>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="发放摘要"
          prop="furinfo"
          :rules="[
            {
              required: state.payModel.bank_account_pay?.b2e_type == 'boc',
              message: '请选择发放摘要',
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            v-model="state.payModel.furinfo"
            placeholder="请选择发放摘要"
            size="large"
          >
            <el-option
              v-for="item in state.bocfurinfo_data"
              :key="item"
              :value="item.value"
              :label="item.name"
            ></el-option>
            <template #footer>
              <el-button size="small" @click="onLoadBocFurInfo()"
                >刷新</el-button
              >
            </template>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="state.showPayForYinQi = false">取消</el-button>
          <el-button type="primary" @click="onSendForYinQi">
            确定发放
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive, ref, h } from "vue";
import {
  salarypayment_record,
  salarypayment_setfailure,
  salarypayment_setdone,
  salarypayment_do,
} from "@/http/salarypayment";
import { priceFormat } from "@/utils/qFormat";
import { ElMessage, ElMessageBox } from "element-plus";
import { attachment_upload } from "@/http/attachment";
import {
  data_b2edictionary_getbocfurinfo,
  data_withholdingagent_account,
} from "@/http/data";

export default {
  props: {
    id: Number,
    model: Object,
  },
  setup(props) {
    const formDom = ref(null);
    const tableDom = ref(null);
    const state = reactive({
      params: {},
      statistics: [],
      templateSortFields: [],
      selectFile: {},
      withholding_agent: {},
      payModel: {},
      files: [],
      uploadModel: {},
    });
    onMounted(() => {
      state.params.id = props.id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      salarypayment_record(state.params).then((res) => {
        if (res.status == 200) {
          const { list, statistics, templateSortFields } = res.data.data;
          state.tableData = list;
          state.statistics = statistics;
          state.templateSortFields = templateSortFields;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      }
      onLoad();
    };

    const getSummaries = () => {
      let res = [];
      res[0] = h("div", { style: { whiteSpace: "nowrap" } }, ["合计"]);
      const keys = Object.keys(state.statistics);
      keys.forEach((key) => {
        const index = state.templateSortFields.findIndex((w) => w.field == key);
        if (index > -1) res[index + 3] = priceFormat(state.statistics[key]);
      });
      return res;
    };

    const onRowClick = (row) => {
      tableDom.value.toggleRowSelection(row);
    };

    const onSetFailure = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.prompt("", "标记失败", {
        confirmButtonText: "标记失败",
        cancelButtonText: "取消",
        inputType: "textarea",
        inputPlaceholder: "请填写备注",
        inputValidator: (val) => {
          return !!val;
        },
        inputErrorMessage: "请填写备注~",
      }).then(({ value }) => {
        const data = {
          id: props.id,
          employee_id: rows.map((m) => m.employee_id).join(","),
          pay_failure_msg: value,
        };

        salarypayment_setfailure(data).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    const onSetDone = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      state.showDone = true;

      // ElMessageBox.confirm(
      //   `您确定将已选的<strong style='color:#1e90ff'>${rows.length}</strong>人置为<strong style='color:#080'>发薪完成</strong>状态吗？`,
      //   "操作提示",
      //   {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning",
      //     dangerouslyUseHTMLString: true,
      //   }
      // ).then(() => {
      //   const data = {
      //     id: props.id,
      //     payroll_employee_id: rows.map((m) => m.id).join(","),
      //   };
      //   salarypayment_setdone(data).then((res) => {
      //     if (res.status == 200) {
      //       ElMessage.success(res.data.msg);
      //       onLoad();
      //     }
      //   });
      // });
    };

    const onSubmitDone = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您确定将已选的<strong style='color:#1e90ff'>${rows.length}</strong>人置为<strong style='color:#080'>发薪完成</strong>状态吗？`,
        "操作提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      ).then(() => {
        const data = {
          id: props.id,
          employee_id: rows.map((m) => m.employee_id).join(","),
          attachment_id: state.uploadModel.attachment_id,
          attachment_remark: state.uploadModel.attachment_remark,
        };
        salarypayment_setdone(data).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
            state.showDone = false;
          }
        });
      });
    };

    const onShowPayForYinQi = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      let accountFunc = new Promise((reslove) => {
        if (state.bank_account_data?.length > 0) {
          reslove();
        } else {
          data_withholdingagent_account({
            withholding_agent_id: props.model?.withholding_agent_id,
          })
            .then((res) => {
              if (res.status == 200) {
                state.bank_account_data = res.data?.data?.list;
              }
              reslove();
            })
            .catch(() => {
              reslove();
            });
        }
      });

      let typeFunc = new Promise((reslove) => {
        if (state.bocfurinfo_data?.length > 0) {
          reslove();
        } else {
          data_b2edictionary_getbocfurinfo()
            .then((res) => {
              if (res.status == 200) {
                state.bocfurinfo_data = res.data.data;
              }
              reslove();
            })
            .catch(() => {
              reslove();
            });
        }
      });

      Promise.all([accountFunc, typeFunc]).then(() => {
        state.showPayForYinQi = true;
      });
    };

    const onChangeFile = (file) => {
      const formData = new FormData();
      formData.append("file[]", file.raw);
      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          res.data.data.forEach((e) => {
            state.files.push(e);
          });
          state.uploadModel.attachment_id = state.files
            .map((m) => m.id)
            .join(",");
        }
      });
    };

    const onSendForYinQi = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          const rows = tableDom.value.getSelectionRows();
          if (rows.length <= 0) {
            ElMessage({
              type: "warning",
              message: "请选择要操作的数据！",
              grouping: true,
            });
            return false;
          }

          ElMessageBox.confirm(
            `您本次共勾选<strong style='color:#1e90ff'>${rows.length}</strong>人，确定调用银企接口为其发放薪资？`,
            "操作提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              dangerouslyUseHTMLString: true,
            }
          ).then(() => {
            const data = {
              id: props.id,
              employee_id: rows.map((m) => m.employee_id).join(","),
              bank_account_pay_id: state.payModel?.bank_account_pay?.id,
              furinfo: state.payModel.furinfo,
            };
            salarypayment_do(data).then((res) => {
              if (res.status == 200) {
                ElMessage.success(res.data.msg);
                state.showPayForYinQi = false;
                onLoad();
              }
            });
          });
        }
      });
    };

    return {
      state,
      tableDom,
      props,
      onLoad,
      onSortChange,
      getSummaries,
      onSetFailure,
      onSetDone,
      onRowClick,
      onShowPayForYinQi,
      onSendForYinQi,
      onChangeFile,
      formDom,
      onSubmitDone,
    };
  },
};
</script>
<style lang="less">
.payroll-dialog {
  .el-dialog__body {
    flex: 1;
    overflow: hidden;
  }
}
</style>
